import store from '@/store/index.js'

export function listenEventFromPinaToVuex () {
  window.addEventListener('update.vuex.state.from.pinia', ({ detail }) => {
    const { eventType, data } = detail
    const eventHandlers = {
      PINIA_UPDATE_REGISTRATION_STEP: () => store.commit('updateRegistrationStep', data),
      PINIA_UPDATE_USER_LOGGED_IN: () => store.commit('setisLoggedInFromPinia', data),
      PINIA_USER_FETCH_FINISHED: () => store.commit('setIsUserFetchFinishedFromPinia', data),
      PINIA_AUTH_ERROR: () => store.commit('setErrorCodeFromPinia', data),
      PINIA_UPDATE_USER_DETAILS: () => store.commit('setUserDetailsFromPinia', data),
      PINIA_SET_APP_LOADER: () => store.commit('setAppLoaderFromPinia', data),
      PINIA_UPDATE_ENGAGEMENT_INFO: () => store.commit('rewardsStore/setEngagementInfo', data),
      PINIA_UPDATE_HISTORY_VIEWED: () => store.commit('rewardsStore/setIsHistoryViewed', data),
      PINIA_UPDATE_CURRENT_COMPANY_ID: () => store.commit('setCurrentCompanyIdFromPinia', data),
      PINIA_UPDATE_CURRENT_COMPANY_INFO: () => store.commit('setCurrentCompanyInfoFromPinia', data),
      PINIA_UPDATE_TENANT_LIST: () => store.commit('setTenantListFromPinia', data),
      PINIA_UPDATE_TENANT_ID: () => store.commit('setTenantIdFromPinia', data)
    }
    if (eventHandlers[eventType]) {
      eventHandlers[eventType]()
    }
  })
}

export function removeEventListenerFromPiniaToVuex () {
  window.removeEventListener('update.vuex.state.from.pinia', eventListenerStopped)
}

function eventListenerStopped () {
  console.log('event listerning ended...')
}
